import React from 'react'
import { FC, CSSProperties } from 'react'

import { setStyle, buildStyles } from 'shared/styleHelpers'
import { DonorRollDataGridRow } from './DonorRollDataGridRow'
import { ShowAllRow } from 'shared/components/ShowAllRow'

import './DonorRollDataGrid.less'

export interface StyleProps {
    dataGridEvenStyle?: CSSProperties
    dataGridOddStyle?: CSSProperties
    donorAvatarStyle?: CSSProperties
    subTitleStyle?: CSSProperties
    titleStyle?: CSSProperties
    anonymousDonorVerbiage: string
    anonymousAmountVerbiage: string
    designationVerbiage: string
    includeDesignation: boolean | undefined
}

export interface DataProps {
    data?: ApiDonorRollDataRecord[]
    donorRollSettings?: DonorRollSettingsDto
    showSubTitle: boolean
    overrideDisplayLimit: boolean
    toggleOverrideDisplayLimit: () => void
    showTitle: boolean
    showModule: boolean
    controlId: number
}

export type DonorRollDataGridProps = StyleProps & DataProps

export type RenderStylesProps = DonorRollDataGridProps & { donorRollSettings: DonorRollSettingsDto }

export const RenderDonorRollStyles: FC<RenderStylesProps> = ({ controlId, ...props }) =>
    <>
        {props.titleStyle && setStyle(` .scoreboard-id-${controlId} h2 ${buildStyles(props.titleStyle)} `)}
        {props.subTitleStyle && setStyle(`.scoreboard-id-${controlId} h3 ${buildStyles(props.subTitleStyle)}`)}
        {props.donorAvatarStyle && setStyle(`.scoreboard-id-${controlId} .data-grid-rows .data-grid-row .avatar ${buildStyles(props.donorAvatarStyle)}`)}
        {props.dataGridEvenStyle && setStyle(` .scoreboard-id-${controlId} .data-grid-rows .data-grid-row:nth-child(even) ${buildStyles(props.dataGridEvenStyle)}`)}
        {props.dataGridOddStyle && setStyle(` .scoreboard-id-${controlId} .data-grid-rows .data-grid-row:nth-child(odd) ${buildStyles(props.dataGridOddStyle)}`)}
        {
            (props.donorRollSettings.layoutSettings.overrideCssEnabled &&
                props.donorRollSettings.layoutSettings.overrideCss) && setStyle(`
                ${props.donorRollSettings.layoutSettings.overrideCss.split('.scoreboard-container').join(`.scoreboard-id-${controlId} .scoreboard-container`)}`)
        }
    </>

RenderDonorRollStyles.displayName = 'RenderDonorRollStyles'

export const DonorRollDataGrid: FC<DonorRollDataGridProps> = props => {
    if (!props.donorRollSettings) {
        return (<div className="scoreboard-container" />)
    }

    const { controlId } = props
    const layoutSettings = props.donorRollSettings.layoutSettings
    const showAllVerbiage = props.donorRollSettings.layoutSettings.showAllVerbiage
    const data = props.data ? props.data : []
    const dataToDisplay = props.overrideDisplayLimit ? data : data.slice(0, layoutSettings.displayLimit)

    return (
        <>
            <RenderDonorRollStyles {...props} donorRollSettings={props.donorRollSettings} />
            <div className="desktop-scoreboard">
                <div className={`scoreboard-id-${controlId}`}>
                    <div className="scoreboard-container">
                        {
                            props.showTitle &&
                            <h2>{props.donorRollSettings.moduleTitle}</h2>
                        }
                        {
                            props.showSubTitle &&
                            <h3>{props.donorRollSettings.moduleSubTitle}</h3>
                        }
                        {props.data && props.showModule && props.donorRollSettings &&
                            <div className="data-grid-container">
                                <div className="data-grid-rows">
                                    {dataToDisplay.map((row, index) => (
                                        <DonorRollDataGridRow key={index} data={row} donorRollSettings={props.donorRollSettings!} anonymousAmountVerbiage={props.anonymousAmountVerbiage} anonymousDonorVerbiage={props.anonymousDonorVerbiage} designationVerbiage={props.designationVerbiage} includeDesignation={props.includeDesignation} />)
                                    )}
                                    {data.length > layoutSettings.displayLimit &&
                                        <ShowAllRow
                                            showAllVerbiage={showAllVerbiage}
                                            overrideDisplayLimit={props.overrideDisplayLimit}
                                            toggleOverrideDisplayLimit={props.toggleOverrideDisplayLimit}
                                        />}
                                </div >
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

DonorRollDataGrid.displayName = 'DonorRollDataGrid'
